// В.2.a: каркас фракции Лив Лайф. Регистратор подгрузчика.
//
// На В.2.a ни одной конкретной способности нет — но импорт нужен, чтобы:
//   - warn-unimplemented активировался;
//   - heal-auras модуль был загружен (хил-Ауры будут регистрироваться
//     в В.2.b … В.2.h, в каркасе пуст);
//   - resurrect утилита была доступна (используется будущими картами).

import './warn-unimplemented.js';
import './heal-auras.js';
import './resurrect.js';
import './hero-actives.js';
import './heal.js';
// C.1: Передовая медицина — фракционная аура Лив Лайфа.
import { registerLivLifeFrontlineMedicine } from '../../factions/livlife.js';
registerLivLifeFrontlineMedicine();

// C.1: новые Герои/карты Лив Лайфа (v6 ID).
import './c1/klod.js';
import './c1/ariana.js';
import './c1/lisa.js';
import './c1/zayn.js';
import './c1/units-batch.js';
import './c1/units-batch2.js';
import { klodOnTurnStart } from './c1/klod.js';
import { arianaOnTurnStart, autoResolveArianaTrigger } from './c1/ariana.js';
import { lisaOnTurnStart } from './c1/lisa.js';
import { zaynOnTurnStart, zaynOnEndOfTurn } from './c1/zayn.js';
import { registerOnTurnStartExtraHandler, registerOnEndOfTurnExtraHandler } from '../deus/hooks.js';

registerOnTurnStartExtraHandler((state) => {
  for (let i = 0; i < state.players.length; i++) {
    klodOnTurnStart(state, i);
    lisaOnTurnStart(state, i);
    zaynOnTurnStart(state, i);
    const arRes = arianaOnTurnStart(state, i);
    if (arRes?.needsPicker) {
      const player = state.players[i];
      if (player?.isBot) autoResolveArianaTrigger(state, i);
    }
  }
});

registerOnEndOfTurnExtraHandler((state) => {
  for (let i = 0; i < state.players.length; i++) {
    zaynOnEndOfTurn(state, i);
  }
});
// В.2.b: 7 common-юнитов (Клон-защитник без файла — он чистый taunt).
import './dron_spasatel.js';
import './polevoy_sanitar.js';
import './paramedik.js';
import './ordinator.js';
import './oshibka_eksperimenta.js';
import './donor.js';
// В.2.c: 3 common-Действия.
import './sint_kozha.js';
import './v_karantin.js';
import './inektsiya_adrenalina.js';
import './actions.js';
// В.2.d-1: 3 простых rare-юнита (Голиаф — без файла, чистый taunt).
import './dron_defibrillyator.js';
import './reanimator.js';
// В.2.d-2: 3 сложных rare-юнита + общая инфра EOT-триггеров и summon.
import './eot-triggers.js';
import './summon.js';
import './laboratornaya_krysa.js';
import './opytnyy_hirurg.js';
import './medik_shturmovik.js';
// В.2.d-3: 2 rare-Действия + интеграция Посмертного контракта в смерть.
// posthumous_contract.js регистрирует extra-handler ПОСЛЕ reanimator —
// порядок обеспечивается порядком импортов (Реаниматор вызывается раньше).
import './perelivanie_krovi.js';
import './otsifrovka_dushi.js';
import './posthumous_contract.js';
// В.2.e-1: 3 epic Лив Лайф (простые) + каркас on_attack триггеров.
import './on-attack-triggers.js';
import './eksperiment_42.js';
import './netranner_himery.js';
import './pravaya_ruka_lizy.js';
// В.2.e-2: 2 сложных epic-юнита + epic-Действие + общие утилиты.
import './on-damage-triggers.js';
import './destroy.js';
import './glavnaya_laboratoriya.js';
import './podopytnyy_alfa.js';
import './virus_hv_14.js';
// В.2.f-1: 2 legendary-юнита.
import './matritsa_klonirovaniya.js';
import './doktor_franken.js';
// В.2.f-2: 3 legendary-Действия.
import './toksichnoe_oblako.js';
import './posledniy_dovod.js';
import './proekt_obgorevshiy_feniks.js';
// В.2.g: пассивки/триггеры 5 Героев Лив Лайф (активки — В.2.h).
import './arena.js';
import './bork.js';
import './liza.js';
import './bessmertnyy.js';
import './zeyn.js';
// В.2.h: активки 5 Героев Лив Лайф.
import './arena_active.js';
import './bork_active.js';
import './liza_active.js';
import './bessmertnyy_active.js';
import './zeyn_active.js';
// В.2.i: каркас start-of-turn-триггеров + 4 новые карты.
//   Стволовой Клон — без файла (чистый taunt из xlsx).
import './start-of-turn-triggers.js';
import './boevoy_biotehnik.js';
import './holodilnik_organov.js';
import './bio_rezervuar.js';

export {
  arenaActive, arenaActiveAvailable, getArenaActiveTargets
} from './arena_active.js';
export {
  borkActive, borkActiveAvailable, getBorkActiveTargets
} from './bork_active.js';
export {
  lizaActive, lizaActiveAvailable, getLizaActiveTargets
} from './liza_active.js';
export {
  bessmertnyyActive, bessmertnyyActiveAvailable, getBessmertnyyActiveTargets
} from './bessmertnyy_active.js';
export {
  zeynActive, zeynActiveAvailable, getZeynActiveTargets
} from './zeyn_active.js';

export { resurrectUnit } from './resurrect.js';
export {
  LIVLIFE_HERO_IDS,
  isLivLifeHero,
  livLifeHeroActiveAvailable,
  livLifeHeroActiveNoop
} from './hero-actives.js';
export {
  registerLivLifeHealAura,
  runLivLifeHealAuras,
  _resetLivLifeHealAurasForTests,
  _hasLivLifeHealAuraForTests
} from './heal-auras.js';
export {
  registerImplementedAbility as registerLivLifeImplementedAbility,
  warnUnimplementedLivLifeAbilities,
  _resetLivLifeWarnCacheForTests
} from './warn-unimplemented.js';
export {
  healUnit,
  registerOnHealTrigger,
  runOnHealTriggers,
  _resetOnHealTriggersForTests
} from './heal.js';
